import { bool, func, string } from 'prop-types';
import React from 'react';
import {
  Button,
  Col,
  FormGroup,
  Input,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from 'reactstrap';

import { DISCRETIONARY_MEDIA } from '../../campaign-editor/constants';
import { commercialIncentivesOptions } from '../../constants';
import SingleSelect from '../../generic/SingleSelect';
import { getTooltipLabelWithText } from '../../generic/Tooltip';
import HELP_TEXTS from '../utils/help-texts';

const CommercialIncentiveModal = ({
  commercialIncentive,
  additionalDetails,
  onChange,
  toggleCommercialIncentiveModal,
  isCommercialIncentiveModalVisible,
}) => {
  const TooltipLabel = getTooltipLabelWithText(HELP_TEXTS);

  return (
    <Modal isOpen={isCommercialIncentiveModalVisible} size="md">
      <>
        <ModalHeader>Please provide a commercial incentive</ModalHeader>
        <ModalBody>
          <FormGroup row>
            <Col sm={12}>
              <SingleSelect
                options={commercialIncentivesOptions}
                id="qu-commercialIncentive"
                name="commercialIncentive"
                value={commercialIncentive}
                onChange={onChange}
              />
            </Col>
          </FormGroup>
          {commercialIncentive === DISCRETIONARY_MEDIA && (
            <FormGroup row>
              <TooltipLabel
                helpKey="additionalDetails"
                text="Additional Details"
                colWidth={3}
                resource="qu"
                className="required"
              />
              <Col sm={9}>
                <Input
                  id="qu-additionalDetails"
                  name="additionalDetails"
                  value={additionalDetails}
                  type="textarea"
                  onChange={onChange}
                />
              </Col>
            </FormGroup>
          )}
        </ModalBody>
        <ModalFooter>
          <Button
            onClick={() => toggleCommercialIncentiveModal(false)}
            color="primary"
          >
            Save
          </Button>
        </ModalFooter>
      </>
    </Modal>
  );
};

CommercialIncentiveModal.propTypes = {
  commercialIncentive: string.isRequired,
  additionalDetails: string,
  onChange: func.isRequired,
  toggleCommercialIncentiveModal: func.isRequired,
  isCommercialIncentiveModalVisible: bool.isRequired,
};

CommercialIncentiveModal.defaultProps = {
  additionalDetails: '',
};

export default CommercialIncentiveModal;
